"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Paragraph = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;

var _polished = require("polished");

var _styledComponents = require("styled-components");

/**
 *
 * @deprecated use Norma typography instead:
 * https://remote-com.gitlab.io/employ-starbase/dragon
 *
 *   @example:
 *${({ theme }) => theme.typography.titleXXL};
 */
var H1 = (0, _styledComponents.css)(["font-weight:500;font-size:", ";line-height:", ";"], (0, _polished.rem)('26px'), (0, _polished.rem)('31px'));
/**
 *
 * @deprecated use Norma typography instead:
 * https://remote-com.gitlab.io/employ-starbase/dragon
 *
 *   @example:
 *${({ theme }) => theme.typography.titleXXL};
 */

exports.H1 = H1;
var H2 = (0, _styledComponents.css)(["font-weight:500;font-size:", ";line-height:", ";"], (0, _polished.rem)('24px'), (0, _polished.rem)('29px'));
/**
 *
 * @deprecated use Norma typography instead:
 * https://remote-com.gitlab.io/employ-starbase/dragon
 *
 *   @example:
 *${({ theme }) => theme.typography.titleXXL};
 */

exports.H2 = H2;
var H3 = (0, _styledComponents.css)(["font-weight:500;font-size:", ";line-height:", ";"], (0, _polished.rem)('22px'), (0, _polished.rem)('26px'));
/**
 *
 * @deprecated use Norma typography instead:
 * https://remote-com.gitlab.io/employ-starbase/dragon
 *
 *   @example:
 *${({ theme }) => theme.typography.titleXXL};
 */

exports.H3 = H3;
var H4 = (0, _styledComponents.css)(["font-weight:500;font-size:", ";line-height:", ";"], (0, _polished.rem)('18px'), (0, _polished.rem)('22px'));
/**
 *
 * @deprecated use Norma typography instead:
 * https://remote-com.gitlab.io/employ-starbase/dragon
 *
 *   @example:
 *${({ theme }) => theme.typography.titleXXL};
 */

exports.H4 = H4;
var H5 = (0, _styledComponents.css)(["font-weight:500;font-size:", ";line-height:", ";"], (0, _polished.rem)('16px'), (0, _polished.rem)('19px'));
/**
 *
 * @deprecated use Norma typography instead:
 * https://remote-com.gitlab.io/employ-starbase/dragon
 *
 *   @example:
 *${({ theme }) => theme.typography.titleXXL};
 */

exports.H5 = H5;
var Paragraph = (0, _styledComponents.css)(["font-weight:normal;font-size:", ";line-height:", ";color:", ";"], (0, _polished.rem)('14px'), (0, _polished.rem)('17px'), function (_ref) {
  var $type = _ref.$type;
  return $type === 'secondary' ? 'var(--colors-lynch)' : 'inherit';
});
exports.Paragraph = Paragraph;